import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { EsgComponent } from './pages/esg/esg.component';
import { RouterModule } from '@angular/router';
import { SharedModule } from '../../shared/shared.module';



@NgModule({
  declarations: [
    EsgComponent
  ],
  imports: [
    CommonModule,
    RouterModule,
    SharedModule
  ]
})
export class EsgModule { }
